var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.roleRGV)?_c('dashboard-statistika'):_vm._e(),(_vm.roleDT)?_c('dashboard-paslaugos',{staticClass:"mb-5"}):_vm._e(),(_vm.roleDT || _vm.roleSkaito)?_c('dashboard-pranesimai'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }